export const newline = /^(?: *(?:\n|$))+/
